var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile shadow"},[_c('energo-widget')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }